// @spec NIS2-STR-063
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { GapPriorityRuleList } from '@/features/nis2/components/GapPriorityRuleList';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/settings/nis2-gap-priority')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2GapPriorityRules'),
  }),
  component: NIS2GapPriorityPage,
});

function NIS2GapPriorityPage() {
  const { t } = useTranslation('settings');
  const { isAdmin } = useOrgRole();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-4xl space-y-8">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">
            {t('nis2GapPriorityPage.title')}
          </h1>
          <p className="mt-1 text-muted-foreground">{t('nis2GapPriorityPage.description')}</p>
        </header>

        <section className="space-y-6">
          <GapPriorityRuleList isAdmin={isAdmin} />
        </section>
      </div>
    </div>
  );
}
